export default {
  english: {
    error: 'Error while resetting, try again',
    success: 'Reset password e-mail sent.',
    reset: 'Reset password',
  },
  french: {
    error: 'Erreur lors de la réinitialisation, réessayez',
    success: 'E-mail de réinitialisation envoyé.',
    reset: 'Réinitialiser le mot de passe',
  },
  arabic: {
    error: 'وقع خطأ عند المسح حاول ثانية',
    success: 'أرسلت الى بريدك الالكتروني رسالة لمسح كلمة المرور.',
    reset: 'مسح كلمة المرور',
  },
  hebrew: {
    error: 'שגיאה במהלך האיפוס, נסה שנית',
    success: 'דואר אלקטרוני עם איפוס סיסמה נשלח',
    reset: 'איפוס סיסמה',
  },
  persian: {
    error: 'خطا هنگام بازنشانی، دوباره امتحان کنید',
    success: 'بازنشانی رمز عبور ایمیل ارسال شد.',
    reset: 'بازنشانی رمز عبور',
  },
}
